// extracted by mini-css-extract-plugin
module.exports = {"left":"DetailsForm_left__ixVp1","form":"DetailsForm_form__kqn0G"};